import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from "@angular/core";
import { Router } from "@angular/router";
import {
    ButtonV3KindDirective,
    ButtonV3PaletteDirective,
    ButtonV3SizeDirective,
} from "@Front-end/ui/modules/button-v3";
import { IconComponent } from "@Front-end/ui/modules/icon";
import { LocalizeRouterService } from "@gilsdav/ngx-translate-router";
import { TranslateModule } from "@ngx-translate/core";
import { BonusAmountComponent } from "../bonus-amount/bonus-amount.component";

@Component({
    selector: "ls-profile",
    templateUrl: "./profile.component.html",
    styleUrls: ["./profile.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslateModule,
        ButtonV3KindDirective,
        ButtonV3PaletteDirective,
        ButtonV3SizeDirective,
        IconComponent,
        BonusAmountComponent,
    ],
})
export class ProfileComponent {
    constructor(
        private localize: LocalizeRouterService,
        private router: Router,
    ) {
    }

    @Input()
    public isProfilePage: boolean = false;

    public navigate(link: string): void {
        const localizePath = this.localize.translateRoute(link);
        void this.router.navigate([localizePath]);
    }
}
